import { useState } from 'react';
import Button from '../../../components/base/Button';
import RequestQuotePopup from '../../../components/feature/RequestQuotePopup';

export default function CTASection() {
  const [isQuoteOpen, setIsQuoteOpen] = useState(false);

  return (
    <section className="py-20 bg-[#e18033]">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl md:text-5xl font-bold text-white mb-6">
          Ready to Scale Your Bidding & Drafting Capacity?
        </h2>
        <p className="text-xl text-white/90 mb-8 max-w-4xl mx-auto leading-relaxed">
          Don’t let internal bottlenecks force you to decline projects. Send us your project documentation today and receive a rapid, fixed-fee quote starting at $25/hour. Every engagement includes one revision covering the full original scope (requirement changes excluded).</p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">

          <Button
            onClick={() => setIsQuoteOpen(true)}
            variant="outline"
            size="lg"
            className="!border-white !text-[#e18033] !bg-white !hover:bg-gray-100 font-bold"
          >
            Request a Quote
          </Button>
        </div>
      </div>

      <RequestQuotePopup 
        isOpen={isQuoteOpen} 
        onClose={() => setIsQuoteOpen(false)} 
        serviceName="General Inquiry"
      />
    </section>
  );
}
